import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const tabStyle = {
  color: "var(--Brand-700, #076D0D)",
  fontFamily: "Montserrat",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  padding: "0px 4px 12px 4px",
  textTransform: "none",
  minHeight: "fit-content",
  minWidth: "fit-content",
};

const TABS = ["home", "network", "groups", "goService", "activity"] as const;
type TabType = (typeof TABS)[number];

const TabsNavigation = ({ isOwn }: { isOwn?: boolean }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "header" });

  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "home";

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    Array.from(searchParams.keys()).forEach((key) => {
      searchParams.delete(key);
    });
    searchParams.set("tab", newValue);

    navigate({ search: searchParams.toString() });
  };

  return (
    <Tabs
      value={currentTab}
      onChange={handleTabChange}
      aria-label="profile tabs"
      sx={{
        minHeight: "fit-content",
        width: "fit-content",
        "& .MuiTabs-flexContainer": {
          gap: "24px",
        },
      }}
    >
      {TABS.map((tab) => {
        if (tab === "groups" && !isOwn) {
          return null;
        }
        return <Tab key={tab} label={t(tab)} value={tab} sx={tabStyle} />;
      })}
    </Tabs>
  );
};

export default TabsNavigation;
